import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as api from "@/api/overseasChinese/overseasChinese";
export default {
  name: "Special",
  props: [],
  data: function data() {
    return {
      semesterList: [],
      loading: false,
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        courseName: "",
        semesterId: ""
      },
      total: 0
    };
  },
  computed: {},
  created: function created() {
    this.getSemesterData();
  },
  methods: {
    getSemesterData: function getSemesterData() {
      var _this = this;

      api.getSemesterSel().then(function (_ref) {
        var data = _ref.data;
        _this.semesterList = data.data;
        var arr = data.data.find(function (item) {
          return item.current == 1;
        }) || data.data[0];
        _this.paramSearch.semesterId = arr.id;

        _this.getList();
      });
    },
    // 获取查询列表
    getList: function getList() {
      var _this2 = this;

      this.loading = true;
      api.selectPCAttendance(this.paramSearch).then(function (res) {
        _this2.loading = false;

        if (res.data.code == 0) {
          _this2.list = res.data.data.records || [];
          _this2.total = res.data.data.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.paramSearch = _objectSpread(_objectSpread({}, this.paramSearch), {}, {
        current: 1
      });
      this.getList();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getList();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getList();
    },
    statusFormat: function statusFormat(row) {
      var status = row.status;

      switch (status) {
        case "1":
          return "正常";

        case "2":
          return "迟到";

        case "3":
          return "早退";

        case "4":
          return "缺勤";

        case "5":
          return "补卡待审核";

        default:
          return "";
      }
    },
    formatDay: function formatDay(row) {
      switch (row.day) {
        case "1":
          return "星期一";

        case "2":
          return "星期二";

        case "3":
          return "星期三";

        case "4":
          return "星期四";

        case "5":
          return "星期五";

        case "6":
          return "星期六";

        case "7":
          return "星期天";

        default:
          return "";
      }
    },
    knobFormat: function knobFormat(row) {
      return row.knob + "节次";
    },
    toDetail: function toDetail(info) {
      this.$router.push({
        path: "/evaluation",
        query: {
          info: JSON.stringify(info)
        }
      });
    }
  },
  watch: {},
  filters: {}
};